<form id="" class="admin_form" [formGroup]="formData" *ngIf="data">
    <div class="form-group">
        <label>Full Name:</label> <small class="pull-right">[A-Z , a-z , 0-9 ] Allowed</small><br>
        <input type="text" name="Demo" formControlName="name" id="" class="form-control">
    </div>
    <!-- <div class="form-group">
        <label>Credit Reference:</label> <small class="pull-right">(0 To 171,915,997.00 MAX)</small><br>
        <input type="text" value="710000" name="" id="" class="form-control">
    </div> -->
    <div *ngFor="let item of eventTypes;let i=index;trackBy:trackByIndex;">
    <div class="form-group" *ngIf="!(env.hidePartenerShips.includes(item?.id)) && data[0]?.partnership[item?.id]">
        <label>Ratio ({{item?.name}}):</label> 
        <input type="text" readonly name="" [value]="data[0]?.partnership[item?.id]" id="" class="form-control">
    </div>
    </div>
    
    <!-- <div class="form-group">
        <label>Master Password:</label><br>
        <input type="password" value="" name="" id="" class="form-control">
    </div> -->
    <div class="form-group">
        <div class="btn-group">
            <button class="btn btnSubmit" (click)="onSubmit()">submit</button>
            <button class="btn btnCancel" (click)="cancel()">cancel</button>
        </div>
    </div>
    <app-loader class="full-overlay" *ngIf="submit"></app-loader>
</form>

<app-loader class="no-overlay" *ngIf="!data"></app-loader>